import React, { memo } from 'react';
import './DishQuantity.scss';
import PropTypes from 'prop-types';
import { addDish, removeDish, removeDishWithOptions } from '@store/actions/menu';
import { connect } from 'react-redux';

const DishQuantity = ({ addDish, removeDish, removeDishWithOptions, className, order }) => {
  const { count } = order;

  const handleRemove = (e) => {
    e.stopPropagation();
    // Use appropriate remove action based on whether order has options
    if (order.options && order.options.length > 0) {
      removeDishWithOptions(order);
    } else {
      removeDish(order);
    }
  };

  const handleAdd = (e) => {
    e.stopPropagation();
    addDish(order);
  };

  return (
    <div>
      {count === 0 && (
        <div className='dish-quantity__empty' onClick={handleAdd}>
          +
        </div>
      )}
      {count > 0 && (
        <div className={`dish-quantity__select ${className}`}>
          <div className='dish-quantity__select--left' onClick={handleRemove}>
            -
          </div>
          <div className='dish-quantity__select--quantity'>{count}</div>
          <div className='dish-quantity__select--right' onClick={handleAdd}>
            +
          </div>
        </div>
      )}
    </div>
  );
};

DishQuantity.propTypes = {
  place: PropTypes.object.isRequired,
  orders: PropTypes.object.isRequired,
  dish: PropTypes.object,
  addDish: PropTypes.func.isRequired,
  removeDish: PropTypes.func.isRequired,
  removeDishWithOptions: PropTypes.func.isRequired,
};

const mapStateToProps = ({ place }) => ({
  place: place.details.data,
  orders: place.menu,
  dish: undefined,
});

const mapDispatchToProps = {
  addDish,
  removeDish,
  removeDishWithOptions,
};

export default memo(connect(mapStateToProps, mapDispatchToProps)(DishQuantity));
